import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=57235164&scoped=true&"
import script from "./DateTime.vue?vue&type=script&lang=ts&"
export * from "./DateTime.vue?vue&type=script&lang=ts&"
import style0 from "./DateTime.vue?vue&type=style&index=0&id=57235164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57235164",
  null
  
)

export default component.exports